export const SIGN_IN_SUCCESS = 'Signed in successfully';
export const SIGN_OUT_SUCCESS = 'Signed out successfully';
